import {
  Checkbox,
  CheckboxGroup,
  Text
} from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow from '../../reusable/Layout';

const STATUS_OPTIONS = [
  { id: 'statusVoid', label: 'RL_Void' },
  { id: 'statusResume', label: 'RL_Resume' },
  { id: 'statusSuspend', label: 'RL_Suspend' },
  { id: 'statusDelivered', label: 'RL_Delivered' },
];

const StatusSelectors = ({ onFilterValueChange, translations }) => {
  const nposFilters = useSelector((state) => state.nposFilters);
  return (
    <FilterRow>
      <Text className="filter-name">{translations.RL_Status}</Text>
      <CheckboxGroup
        data-testid="status-checkbox-group"
        onChange={(e) => onFilterValueChange({ id: e.target.id, value: !nposFilters[e.target.id] })}
      >
        {STATUS_OPTIONS.map(({ id, label }) => (
          <Checkbox
            key={id}
            checked={nposFilters[id]}
            data-testid={`status-checkbox-${id}`}
            id={id}
            label={translations[label]}
          />
        ))}
      </CheckboxGroup>
    </FilterRow>
  );
};

StatusSelectors.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default StatusSelectors;
